/*
 * Shipping rate estimator for the cart page.
 *
 * The cart section renders #shipping-calculator (country / province / zip + the
 * "get rates" button) but nothing was ever bound to it, so the button did
 * nothing. This wires up the province selector and the /cart/shipping_rates.json
 * lookup.
 */
(function () {
	'use strict';

	var container = null;
	var countrySelect = null;
	var provinceSelect = null;
	var provinceContainer = null;
	var zipInput = null;
	var button = null;
	var response = null;
	var strings = {};
	var requesting = false;

	function t(key, replacements) {
		var value = strings[key] || '';
		if (replacements) {
			Object.keys(replacements).forEach(function (name) {
				value = value.split('[' + name + ']').join(replacements[name]);
			});
		}
		return value;
	}

	function money(price) {
		// The rates endpoint returns a decimal string ("120.00"); the theme's
		// formatter expects cents.
		var cents = Math.round(parseFloat(price) * 100);
		if (isNaN(cents)) return price;
		if (window.wpbingo && wpbingo.Currency && wpbingo.strings) {
			return wpbingo.Currency.formatMoney(cents, wpbingo.strings.moneyFormat);
		}
		return (cents / 100).toFixed(2);
	}

	function escapeHtml(value) {
		return String(value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	function selectByValue(select, value) {
		if (!select || !value) return false;
		var options = select.options;
		for (var i = 0; i < options.length; i++) {
			if (options[i].value === value) {
				select.selectedIndex = i;
				return true;
			}
		}
		return false;
	}

	function provincesForSelectedCountry() {
		var option = countrySelect.options[countrySelect.selectedIndex];
		if (!option) return [];
		var raw = option.getAttribute('data-provinces');
		if (!raw) return [];
		try {
			var parsed = JSON.parse(raw);
			return Array.isArray(parsed) ? parsed : [];
		} catch (e) {
			return [];
		}
	}

	function buildProvinces() {
		if (!provinceSelect || !provinceContainer) return;

		var provinces = provincesForSelectedCountry();
		provinceSelect.innerHTML = '';

		if (!provinces.length) {
			provinceContainer.style.display = 'none';
			return;
		}

		provinces.forEach(function (province) {
			// Shopify returns [value, label] pairs, but be tolerant of plain strings.
			var value = Array.isArray(province) ? province[0] : province;
			var label = Array.isArray(province) ? province[1] : province;
			var option = document.createElement('option');
			option.value = value;
			option.textContent = label;
			provinceSelect.appendChild(option);
		});

		provinceContainer.style.display = '';
		selectByValue(provinceSelect, provinceSelect.getAttribute('data-default'));
	}

	function setResponse(html, isError) {
		response.innerHTML = html;
		response.classList.toggle('error', !!isError);
	}

	function renderRates(rates, address) {
		if (!rates.length) {
			setResponse('<p class="shipping_calculate_mess">' + escapeHtml(t('no_results')) + '</p>', true);
			return;
		}

		var message = rates.length === 1
			? t('one_result', { address: address })
			: t('multiple_results', { count: rates.length, address: address });

		var items = rates.map(function (rate) {
			return '<li>' + escapeHtml(rate.name) + ': ' + money(rate.price) + '</li>';
		}).join('');

		setResponse(
			'<p class="shipping_calculate_mess">' + escapeHtml(message) + '</p>' +
			'<ul class="shipping_calculate_rate">' + items + '</ul>',
			false
		);
	}

	function renderErrors(errors) {
		var messages = [];
		if (errors && typeof errors === 'object') {
			Object.keys(errors).forEach(function (field) {
				var value = errors[field];
				messages = messages.concat(Array.isArray(value) ? value : [value]);
			});
		}
		if (!messages.length) messages.push(t('error'));

		setResponse(
			'<ul class="shipping_calculate_rate">' +
			messages.map(function (message) {
				return '<li>' + escapeHtml(message) + '</li>';
			}).join('') +
			'</ul>',
			true
		);
	}

	function addressLabel(country, province, zip) {
		return [zip, province, country].filter(Boolean).join(', ');
	}

	function getRates() {
		if (requesting) return;

		var country = countrySelect ? countrySelect.value : '';
		var province = (provinceContainer && provinceContainer.style.display !== 'none' && provinceSelect)
			? provinceSelect.value
			: '';
		var zip = zipInput ? zipInput.value.trim() : '';

		var params = new URLSearchParams();
		params.append('shipping_address[country]', country);
		params.append('shipping_address[province]', province);
		params.append('shipping_address[zip]', zip);

		requesting = true;
		button.classList.add('disabled');
		button.disabled = true;
		setResponse('<p class="shipping_calculate_mess">' + escapeHtml(t('calculating')) + '</p>', false);

		fetch(container.getAttribute('data-rates-url') + '?' + params.toString(), {
			method: 'GET',
			headers: { Accept: 'application/json' }
		})
			.then(function (res) {
				return res.json().then(function (data) {
					return { ok: res.ok, data: data };
				});
			})
			.then(function (result) {
				if (!result.ok || !result.data || !result.data.shipping_rates) {
					renderErrors(result.data && result.data.errors);
					return;
				}
				renderRates(result.data.shipping_rates, addressLabel(country, province, zip));
			})
			.catch(function () {
				renderErrors(null);
			})
			.then(function () {
				requesting = false;
				button.classList.remove('disabled');
				button.disabled = false;
			});
	}

	function init() {
		container = document.getElementById('shipping-calculator');
		if (!container) return;

		countrySelect = container.querySelector('#address_country');
		provinceSelect = container.querySelector('#address_province');
		provinceContainer = container.querySelector('#address_province_container');
		zipInput = container.querySelector('#address_zip');
		button = container.querySelector('.get-rates');
		response = container.querySelector('#wrapper-response');

		if (!countrySelect || !button || !response) return;

		try {
			strings = JSON.parse(container.getAttribute('data-strings') || '{}');
		} catch (e) {
			strings = {};
		}

		selectByValue(countrySelect, countrySelect.getAttribute('data-default'));
		buildProvinces();

		countrySelect.addEventListener('change', buildProvinces);
		button.addEventListener('click', function (event) {
			event.preventDefault();
			getRates();
		});
		if (zipInput) {
			zipInput.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') {
					event.preventDefault();
					getRates();
				}
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
